import { Component, NgModule , OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef,
  OnChanges, TemplateRef, ViewChild,} from '@angular/core';
import {DemoService} from '../../../demo.service';
// import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';
import { MysqlService } from './../../../services/mysql.service';

// 
import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {BehaviorSubject, Observable, Subject, map} from 'rxjs';
import { Subscription } from 'rxjs';

import { FileUploaderService } from './../../../services/file-uploader-service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { JobSubject } from './../../../shared/models/jobSubject.model';


declare var jQuery: any;


@Component({
  selector: 'app-subject-delete-widget',
  templateUrl: './subject-delete-widget.component.html',
  styleUrls: ['./subject-delete-widget.component.css']
})
export class SubjectDeleteWidgetComponent implements OnInit {

  // setup as observable?
  @Input() item_id?: Observable<any[]>; // impliments on changes.
  @Input() item_data?: Observable<any[]>; // if data.model is sent : Observable<any[]>;
  @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
  @Input() item_user_level_id? = '5'; // default to agent just in case
  @Input() item_brand_type_id? = '';
  @Input() show_buttons? = 'no'; // yes | no
  @Input() widget_title? = '';
  @Input() widget_size? = 'side'; // side | abstract | full
  @Input() nested? = '0'; // side | abstract | full

  @Output()
change: EventEmitter<number> = new EventEmitter<number>();

//charts
    // Peity chart
  
  
    public peityType1:string = "bar";
    public peityOptions1:any = { fill: ['#1ab394', "#d7d7d7"], width:100};
  
    public peityType2 = "line";
    public peityOptions2:any = { fill: '#1ab394',stroke:'#169c81', width: 64 };
  
    // Sparkline chart
    public sparklineData:Array<any> = [5, 6, 7, 2, 0, 4, 2, 4, 5, 7, 2, 4, 12, 14, 4, 2, 14, 12, 7];
    public sparklineOptions:any = { type: 'bar', barWidth: 8, height: '150px', barColor: '#1ab394', negBarColor: '#c6c6c6'};
  
    public lineChartLabels:Array<any> = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];
    public lineChartType = 'line';
  
    public peityType = "pie";
    public peityOptions:any = { fill: ['#1ab394', '#d7d7d7', '#ffffff']};

@Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();
@Output('closeParentModel2') closeParentModel2: EventEmitter<any> = new EventEmitter();

  job: Object;
  job_id;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;
  subject_id: any;
  subject: any;
  subject_number: any;
  job_number: string;
  model: JobSubject;
  assignedBrandList: any;
  assignedBrandList_count: any;
  assignedBrandList_removed: number;
  subject_count: any;
  subject_contact_emails: any;
  subject_contact_numbers: any;
  subject_model: any;
  subject_contact_emails_count: any;
  subject_contact_numbers_count: any;
  subject_notes: any;
  subject_notes_count: any;
  subject_services: any;
  subject_services_count: any;
  subject_files: any;
  subject_files_count: any;
  subject_system_log: any;
  subject_system_log_count: any;
  subject_communication_history: any;
  subject_communication_history_count: any;
  subject_invoices: any;
  subject_invoice_couunt: number;
  subject_work_orders: Object;
  subject_work_order_couunt: number;
  
  bsModalRef: BsModalRef;
  modalRef: BsModalRef;
  subject_billing_items: any;
  subject_billing_items_count: any;
  subject_cost_items: any;
  subject_cost_items_count: any;
  subject_services_count_removed: number;
  subject_services_removed: number;
  assignedBrandList_count_removed: number;
  subject_contact_numbers_count_removed: number;
  subject_contact_numbers_removed: number;
  subject_contact_emails_removed: number;
  subject_contact_emails_count_removed: number;
  subject_notes_removed: number;
  subject_notes_count_removed: number;
  subject_files_removed: number;
  subject_files_count_removed: number;
  subject_logs_removed: number;
  subject_logs_count_removed: number;
  subject_communication_history_removed: number;
  subject_communication_history_count_removed: number;
  subject_billing_items_removed: number;
  subject_billing_items_count_removed: number;
  subject_cost_items_removed: number;
  subject_cost_items_count_removed: number;
  subject_removed: number;
  subject_count_removed: number;
  del_files: Object;

 constructor(
   private http: HttpClient, private _demoService: DemoService,
   private route: ActivatedRoute,
    vcr: ViewContainerRef, private router: Router,
    public HttpClient:HttpClient,
    private fileUploader: FileUploaderService,
    private _mysqlService: MysqlService,
    private modalService: BsModalService,
    public datepipe: DatePipe,
    public gfunc: GlobalFunctionsService,
 ) {

// Set and Access login Session Variables
this.gfunc.setLoginSessionVars(); // set in a global function file
this.sessionUserId = this.gfunc.currentUserVAR.user_id;
this.sessionUsername = this.gfunc.currentUserVAR.username;
this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

   // need to add this as routes does not work globally
   this.all_router_details = this.router.url;
   this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));


  }

  // check for changes. to load data.
  ngOnChanges(changes) {
   if (changes.item_id) {
     // deal with asynchronous Observable result
     this.subject_id = changes.item_id.currentValue;
     // this.getJob(this.job_id);
    //  this.getJobSubject(this.subject_id);



   }
 }


 ngOnInit() {

  this.getJobSubject(this.subject_id);
       // counts and datas
       this.getSubjectInvoices(this.subject_id);
       this.getSubjectAgentBrandsAssigned(this.subject_id);
       this.getSubjectContactEmails(this.subject_id);
       this.getSubjectContactNumbers(this.subject_id);
       this.getSubjectNotes(this.subject_id);
       this.getSubjectServices(this.subject_id);
       this.getSubjectFiles(this.subject_id);
       this.getSubjectSystemLogs(this.subject_id);
       this.getSubjectCommunicationHistory(this.subject_id);
       this.getSubjectWorkOrders(this.subject_id);
  
       this.getSubjectBillingItems(this.subject_id);
       this.getSubjectCostItems(this.subject_id);
  
 }

 // Functions
getJob(job_id) {
 this._demoService.getJobID(job_id).subscribe(
    data => { this.job = data;
     let res = data[0];
     // Run the job data queries.
   },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}


 // MODAL
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  this.modalRef = this.modalService.show(template);
}


getJobSubject(subject_id) {
  this._demoService.getJobSubject(subject_id).subscribe(
    data => { this.subject = data;
      let res = data[0];
      this.subject_number = res.subject_number;
      this.job_number = res.job_id + '.1'; // made up
      this.subject_count = this.subject.length;
     // console.log("Done loadng USER");
    },
    error => {
    //  console.error('Error Loading User!');
    // return Observable.throw(error);
    }
  );
 }


 // Gets
 getSubjectAgentBrandsAssigned(subject_id) {
  this._demoService.getSubjectAgentBrandsAssigned(subject_id).subscribe(
     data => { this.assignedBrandList = data;
      let res = data[0];
      this.assignedBrandList_count = this.assignedBrandList.length;
      this.assignedBrandList_removed = 0;

    },
     err => console.error(err),
     // () => console.log('Loaded Assigned Agents Loaded.')
   );
 }



 getSubjectContactEmails(subject_id) {
  this._demoService.getSubjectContactEmails(subject_id).subscribe(
     data => { this.subject_contact_emails = data; 
    this.subject_contact_emails_count = this.subject_contact_emails.length;
    
    },
     err => console.error(err),
      () => {
        console.log('done loading SR');
                    }
        );
 }

getSubjectContactNumbers(subject_id) {
  this._demoService.getSubjectContactNumbers(subject_id).subscribe(
     data => { this.subject_contact_numbers = data;
    this.subject_contact_numbers_count = this.subject_contact_numbers.length;
    },
     err => console.error(err),
      () => {
        console.log('done loading SCN');
                    }
        );
 }



 getSubjectNotes(subject_id) {
  this._demoService.getSubjectNotes(subject_id).subscribe(
    data => { this.subject_notes = data;
      this.subject_notes_count = this.subject_notes.length;
     // console.log("Done loadng USER");
     // console.log(this.users);
    },
    error => {
    //  console.error('Error Loading User!');
    // return Observable.throw(error);
    }
  ); }




  getSubjectServices(subject_id) {
    this._demoService.getSubjectServices(subject_id).subscribe(
      data => { this.subject_services = data;
        this.subject_services_count = this.subject_services.length;
       // console.log("Done loadng USER");
       // console.log(this.users);
       let res = data[0];
       // this.getSubjectServiceOutcome(res.subject_service_outcome_id);
       // this.getUsersById(res.who_attended);
      },
      error => {
      //  console.error('Error Loading User!');
      // return Observable.throw(error);
      }
    ); }



    getSubjectFiles(subject_id) {
      this._demoService.getSubjectFiles(subject_id).subscribe(
         data => { this.subject_files = data;
        this.subject_files_count = this.subject_files.length;
        },
         err => console.error(err),
          () => {
            console.log('done loading SCN');
                        }
            );
     }


     getSubjectSystemLogs(subject_id) {
      this._demoService.getSubjectSystemLogs(subject_id).subscribe(
         data => { this.subject_system_log = data;
        this.subject_system_log_count = this.subject_system_log.length;
        },
         err => console.error(err),
          () => {
            console.log('done loading SCN');
                        }
            );
     }


     getSubjectCommunicationHistory(subject_id) {
      this._demoService.getSubjectCommunicationHistory(subject_id).subscribe(
         data => { this.subject_communication_history = data;
        this.subject_communication_history_count = this.subject_communication_history.length;
        },
         err => console.error(err),
          () => {
            console.log('done loading SCN');
                        }
            );
     }     


     getSubjectInvoices(subject_id) {
      this._demoService.getSubjectInvoices(subject_id).subscribe(
         data => { this.subject_invoices = data;
       let res = data[0];
      // this.subject_invoices = res; // only return the first result and save back the the same variable.
       // do a count if exists
       let newArr = Object(this.subject_invoices);
       this.subject_invoice_couunt = Object.keys(newArr).length;
    
        }, // make the same data call for all
         err => console.error(err),
         // () => console.log('done loading Trace Types')
       );
     }
     

     getSubjectWorkOrders(subject_id) {
      this._demoService.getSubjectWorkOrders(subject_id).subscribe(
         data => { this.subject_work_orders = data;
       let res = data[0];
      // this.subject_invoices = res; // only return the first result and save back the the same variable.
       // do a count if exists
       let newArr = Object(this.subject_work_orders);
       this.subject_work_order_couunt = Object.keys(newArr).length;
    
        }, // make the same data call for all
         err => console.error(err),
         // () => console.log('done loading Trace Types')
       );
     }



     
getSubjectBillingItems(subject_id) {
  this._demoService.getSubjectBillingItems(subject_id).subscribe(
    data => { this.subject_billing_items = data;
this.subject_billing_items_count = this.subject_billing_items.length;
     let res = data[0];
     // Run the job data queries.
   },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}


getSubjectCostItems(subject_id) {
  this._demoService.getSubjectCostItems(subject_id).subscribe(
    data => { this.subject_cost_items = data;
      this.subject_cost_items_count = this.subject_cost_items.length;
     let res = data[0];
     // Run the job data queries.
   },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}


     
// deletes (widget mutilple functions)





widgetDeleteSubjectAgentsAssigned(model){
  // loop the function with the results 
  this.assignedBrandList_removed = 0;
  this.assignedBrandList_count_removed = 0;

  let newArr = model;
  let  count_of_items = Object.keys(newArr).length;
  for(let i=0;i < count_of_items; i++) {
     let res = newArr[i];

     this.deleteSubjectAgentAssignedAll(null, this.subject_id);
     // increases the count
     this.assignedBrandList_count_removed++;

  }// end for loop

this.assignedBrandList_removed = 1;

}

widgetDeleteSubjectContactEmails(model){
  // loop the function with the results 
  this.subject_contact_emails_removed = 0;
  this.subject_contact_emails_count_removed = 0;

  let newArr = model;
  let  count_of_items = Object.keys(newArr).length;
  for(let i=0;i < count_of_items; i++) {
     let res = newArr[i];
     this.deleteSubjectContactEmails(newArr[i].subject_id);
     // increases the count
     this.subject_contact_emails_count_removed++;

  }// end for loop

this.subject_contact_emails_removed = 1;

}


widgetDeleteSubjectContactNumbers(model){
  // loop the function with the results 
  this.subject_contact_numbers_removed = 0;
  this.subject_contact_numbers_count_removed = 0;

  let newArr = model;
  let  count_of_items = Object.keys(newArr).length;
  for(let i=0;i < count_of_items; i++) {
     let res = newArr[i];
     this.deleteSubjectContactNumbers(newArr[i].subject_id);
     // increases the count
     this.subject_contact_numbers_count_removed++;

  }// end for loop

this.subject_contact_numbers_removed = 1;

}

widgetDeleteSubjectNotes(model){
  // loop the function with the results 
  this.subject_notes_removed = 0;
  this.subject_notes_count_removed = 0;

  let newArr = model;
  let  count_of_items = Object.keys(newArr).length;
  for(let i=0;i < count_of_items; i++) {
     let res = newArr[i];
     this.deleteSubjectNotes(newArr[i].subject_id);
     // increases the count
     this.subject_notes_count_removed++;

  }// end for loop

this.subject_notes_removed = 1;

}


widgetDeleteSubjectServices(model){
  // loop the function with the results 
  this.subject_services_count_removed = 0;
  this.subject_services_removed = 0;

  let newArr = model;
  let  count_of_items = Object.keys(newArr).length;
  for(let i=0;i < count_of_items; i++) {
     let res = newArr[i];
     this.deleteSubjectsServices(newArr[i].subject_id);
     // increases the count
     this.subject_services_count_removed++;

  }// end for loop

this.subject_services_removed = 1;

}


widgetDeleteSubjectFiles(model){
  // loop the function with the results 
  this.subject_files_removed = 0;
  this.subject_files_count_removed = 0;

  let newArr = model;
  let  count_of_items = Object.keys(newArr).length;
  for(let i=0;i < count_of_items; i++) {
     let res = newArr[i];
     console.log(newArr[i].file_subject_id);
    //  this.deleteSubjectFiles(newArr[i].file_subject_id);

    // this should now remove the file and the physical file
    this.deleteSystemJobFile(newArr[i]);

     // increases the count
     this.subject_files_count_removed++;

  }// end for loop

this.subject_files_removed = 1;

}


widgetDeleteSubjectLogs(model){
  // loop the function with the results 
  this.subject_logs_removed = 0;
  this.subject_logs_count_removed = 0;

  let newArr = model;
  let  count_of_items = Object.keys(newArr).length;
  for(let i=0;i < count_of_items; i++) {
     let res = newArr[i];

     this.deleteSubjectLogs(newArr[i].subject_id);
     // increases the count
     this.subject_logs_count_removed++;

  }// end for loop

this.subject_logs_removed = 1;

}


widgetDeleteSubjectCommunicationHistory(model){
  // loop the function with the results 
  this.subject_communication_history_removed = 0;
  this.subject_communication_history_count_removed = 0;

  let newArr = model;
  let  count_of_items = Object.keys(newArr).length;
  for(let i=0;i < count_of_items; i++) {
     let res = newArr[i];
     this.deleteSubjectCommunicationHistory(newArr[i].subject_id);
     // increases the count
     this.subject_communication_history_count_removed++;

  }// end for loop

this.subject_communication_history_removed = 1;

}


widgetDeleteSubjectBillingItems(model){
  // loop the function with the results 
  this.subject_billing_items_removed = 0;
  this.subject_billing_items_count_removed = 0;

  let newArr = model;
  let  count_of_items = Object.keys(newArr).length;
  for(let i=0;i < count_of_items; i++) {
     let res = newArr[i];
     this.deleteSubjectAllBillingItems(newArr[i].subject_id);
     // increases the count
     this.subject_billing_items_count_removed++;

  }// end for loop

this.subject_billing_items_removed = 1;

}

widgetDeleteSubjectCostItems(model){
  // loop the function with the results 
  this.subject_cost_items_removed = 0;
  this.subject_cost_items_count_removed = 0;

  let newArr = model;
  let  count_of_items = Object.keys(newArr).length;
  for(let i=0;i < count_of_items; i++) {
     let res = newArr[i];
     this.deleteSubjectAllCostItems(newArr[i].subject_id);
     // increases the count
     this.subject_cost_items_count_removed++;

  }// end for loop

this.subject_cost_items_removed = 1;

}


widgetDeleteSubject(model){
  // loop the function with the results 
  this.subject_removed = 0;
  this.subject_count_removed = 0;

  let newArr = model;
  let  count_of_items = Object.keys(newArr).length;
  for(let i=0;i < count_of_items; i++) {
     let res = newArr[i];

     // Need to put in logic to check the subject number...??? what happens.
     this.deleteSubject(newArr[i].subject_id, newArr[i]); // ready to once I fix the file delete
     // increases the count
     this.subject_count_removed++;

  }// end for loop

this.subject_removed = 1;

}


widgetDeleteAllSubjectData() {
    if (confirm('Are you sure you want to delete this subject and all subject data and files.')) {
  this.widgetDeleteSubjectAgentsAssigned(this.assignedBrandList);
  this.widgetDeleteSubjectContactEmails(this.subject_contact_emails);
  this.widgetDeleteSubjectContactNumbers(this.subject_contact_numbers);
  this.widgetDeleteSubjectNotes(this.subject_notes);
  this.widgetDeleteSubjectServices(this.subject_services);
  this.widgetDeleteSubjectFiles(this.subject_files);
  this.widgetDeleteSubjectLogs(this.subject_system_log);
  this.widgetDeleteSubjectCommunicationHistory(this.subject_communication_history);
  this.widgetDeleteSubjectBillingItems(this.subject_billing_items);
  this.widgetDeleteSubjectCostItems(this.subject_cost_items);
  this.widgetDeleteSubject(this.subject);
}
}


// single delete functions



deleteSubjectAgentAssignedAll(item, subject_id) {
  this._demoService.deleteSubjectAgentAssignedAll(item, subject_id).subscribe(
     data => {
       // refresh the list
     //  this.getTraceAssigned(trace_id);
    // this.toastr.success('Agents All Removed');
    //  this.getSubjectAgentAssigned(subject_id);
       return true;
     },
     error => {
       this.assignedBrandList_removed = 3; 
       console.error('Error removing all users from list!');
       return error(error.error);
     }
  );
  
  }
  





 deleteSubjectContactEmails(subject_id) {
  this._demoService.deleteSubjectContactEmails(subject_id).subscribe(
     data => { 
      // this.subject_contact_emails = data;
      // this.toastr.success('Subject Contact Email Removed');
       },
     err => {
      this.subject_contact_emails_removed = 3;
      console.error(err)
    },
      () => {
      //  console.log('done loading SR');
                    }
        );
}


 deleteSubjectContactNumbers(subject_id) {
  this._demoService.deleteSubjectContactNumbers(subject_id).subscribe(
     data => { 
      // this.subject_contact_emails = data;
       },
     err => {
      this.subject_contact_emails_removed = 3;
      console.error(err)
    },
      () => {
      //  console.log('done loading SR');
         }
        );

}



deleteSubjectNotes(subject_id) {
  this._demoService.deleteSubjectNotes(subject_id).subscribe(
    data => { // this.subject_billing_items = data;
    // let res = data[0];
     // Run the job data queries.
  //  this.toastr.success('Subject Billing Item Removed.');
  
    },
    err => {
      this.subject_notes_removed = 3;
      console.error(err)},
    // () => console.log('done loading Trace Types')
  );
}




deleteSubjectFiles(subject_id) {
  this._demoService.deleteSubjectFiles(subject_id).subscribe(
    data => { // this.subject_billing_items = data;
    // let res = data[0];
     // Run the job data queries.
  //  this.toastr.success('Subject Billing Item Removed.');
  
    },
    err => {
      this.subject_files_removed = 3;
      console.error(err)},
    // () => console.log('done loading Trace Types')
  );
}





deleteSubjectsServices(subject_id) {
    this._demoService.deleteSubjectsServices(subject_id).subscribe(
       data => {
        // resets the count
        // this.getSubjectServices(this.subject_id);
        //  return true;
       },
       error => {
        this.subject_services_removed = 3; // reports error.
         console.error('Error deleting subject service!');
        return console.log(error);
       }
    );
}




deleteSubjectService(subject_service_id) {
  if (confirm('Are you sure you want to delete this Service Information? ')) {
    this._demoService.deleteSubjectService(subject_service_id).subscribe(
       data => {
       // this.getSubjectServices(this.subject_id);
        // this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);
         return true;
       },
       error => {
         console.error('Error deleting Attendence!');
        return console.log(error);
       }
    );
}
}

deleteSubjectLogs(subject_id) {
  this._demoService.deleteSubjectLogs(subject_id).subscribe(
    data => { // this.subject_billing_items = data;
    // let res = data[0];
     // Run the job data queries.
  //  this.toastr.success('Subject Billing Item Removed.');
  
    },
    err => {
      this.subject_logs_removed = 3;
      console.error(err)},
    // () => console.log('done loading Trace Types')
  );
}


deleteSubjectCommunicationHistory(subject_id) {
  this._demoService.deleteSubjectCommunicationHistory(subject_id).subscribe(
    data => { // this.subject_billing_items = data;
    // let res = data[0];
     // Run the job data queries.
  //  this.toastr.success('Subject Billing Item Removed.');
  
    },
    err => {
      this.subject_communication_history_removed = 3;
      console.error(err)},
    // () => console.log('done loading Trace Types')
  );
}



deleteSubjectAllBillingItems(subject_id) {
  this._demoService.deleteSubjectAllBillingItems(subject_id).subscribe(
    data => { // this.subject_billing_items = data;
    // let res = data[0];
     // Run the job data queries.
  //  this.toastr.success('Subject Billing Item Removed.');
  
    },
    err => {
      this.subject_billing_items_removed = 3;
      console.error(err); 
    },
    // () => console.log('done loading Trace Types')
  );
}


deleteSubjectAllCostItems(subject_id) {
  this._demoService.deleteSubjectAllCostItems(subject_id).subscribe(
    data => { // this.subject_billing_items = data;
    // let res = data[0];
     // Run the job data queries.

    },
    err => {
      this.subject_cost_items_removed = 3;
      console.error(err); 
    },
    // () => console.log('done loading Trace Types')
  );
}



deleteSubject(subject_id, model) {
  this._demoService.deleteSubject(subject_id).subscribe(
    data => { // this.subject_billing_items = data;
    // let res = data[0];
     // Run the job data queries.
  //  this.toastr.success('Subject Billing Item Removed.');



  // New log on delete subject
  this.gfunc.insertLog_DeleteSubject(model); 
  
    },
    err => {
      this.subject_removed = 3;
      console.error(err); 
    },
    // () => console.log('done loading Trace Types')
  );
}



// this deletes the lot!
deleteSystemJobFile(model) {
  console.log('FileID: ', model.file_id);
  // change into a subscruption and delete the file action.
// 1: delete from database + Log action
this.deleteSystemFileAssigned(model);
// 2: Delete file from server
this.deleteSystemFile(model);
// logg the process
// this.gfunc.insertLog_DeleteSystemFile(model);
// 3: Delete the pysical file from the server file
if (model.file_server_location !== '') {
this.deleteJobFileAny(model.full_file_name, model.file_job_id, model.file_make, model.file_server_location);
console.log('physicalFILEdelete active: ');
// find out what type of tile it is and then detete the file.
}
console.log('Success: Data + File deleted', model.file_id + ' ' + model.full_file_name);
// this.refreshGrid();
  // this.router.navigate(['/admin/system-file-manager/system-file/' + file_id + '']);
 // this.gfunc.globalViewSystemFile(file_id);

}




deleteSystemFileAssigned(model){
  this._demoService.deleteSystemFileAssigned(model).subscribe(
    (res) => (
      this.del_files = res,
      console.log('Assigned Files deleted', model.file_id + ' ' + model.full_file_name)
      // this.files_table = this.files.slice(0, 10)
      ),
    (err) => console.error(err.status)
  );
}

deleteSystemFile(model){
  this._demoService.deleteSystemFile(model).subscribe(
    (res) => (
      this.del_files = res,
      console.log('File deleted', model.file_id + ' ' + model.full_file_name)
      // this.files_table = this.files.slice(0, 10)
      ),
    (err) => console.error(err.status)
  );
}


// New delete any job or subject file fuction - Beta Testing
deleteJobFileAny(filename, job_id, file_make, file_server_location) {
  // if (confirm('Are you sure you want to delete this file? ')) {
    this._mysqlService.deleteJobFileAny(filename, job_id, file_make, file_server_location).subscribe(
       data => {
         // this.getTraceNotes(this.trace_id);
         return true;
       },
       error => {
         console.error('Error deleting Job File!');
        return console.log(error);
       }
    );
// }
}





refreshPage(){
  // reload all the counts.
  this.getJobSubject(this.subject_id);
  // counts and datas
  this.getSubjectInvoices(this.subject_id);
  this.getSubjectAgentBrandsAssigned(this.subject_id);
  this.getSubjectContactEmails(this.subject_id);
  this.getSubjectContactNumbers(this.subject_id);
  this.getSubjectNotes(this.subject_id);
  this.getSubjectServices(this.subject_id);
  this.getSubjectFiles(this.subject_id);
  this.getSubjectSystemLogs(this.subject_id);
  this.getSubjectCommunicationHistory(this.subject_id);
  this.getSubjectWorkOrders(this.subject_id);

  this.getSubjectBillingItems(this.subject_id);
  this.getSubjectCostItems(this.subject_id);

// refresh the counts
this.subject_services_count_removed= null;
this.subject_services_removed= null;
this.assignedBrandList_count_removed= null;
this.subject_contact_numbers_count_removed= null;
this.subject_contact_numbers_removed= null;
this.subject_contact_emails_removed= null;
this.subject_contact_emails_count_removed= null;
this.subject_notes_removed= null;
this.subject_notes_count_removed= null;
this.subject_files_removed= null;
this.subject_files_count_removed= null;
this.subject_logs_removed= null;
this.subject_logs_count_removed= null;
this.subject_communication_history_removed= null;
this.subject_communication_history_count_removed= null;
this.subject_billing_items_removed= null;
this.subject_billing_items_count_removed= null;
this.subject_cost_items_removed= null;
this.subject_cost_items_count_removed= null;
this.subject_removed= null;
this.subject_count_removed= null;

}




}